/* 
This script is designed to be used in conjunction with 1 leverJQueryDCI component, 1 heroBannerDCI component, and 9 fixedWidthTextDCI components.
Specific ID elements are required, and they are as follows:
leverJQueryDCI - #lever-job-id. This element must be placed on the same page as the heroBannerDCI and fixedWidthTextDCI components.
heroBannerDCI - #job-title.
fixedWidthTextDCI - #commitment-location, #apply-button-1, #apply-button-2, #job-overview, #job-day-header, #job-day-content, #job-needs-header, #job-needs-content, #job-benefits.
*/
'use strict';

$(window).on('load', function () {
    var jobIdElement = document.getElementById('lever-job-id');
    var dataProperties = document.getElementById('dataProperties');
    var openjob = 0;

    if (jobIdElement && jobIdElement.value) {
        $.get(
            dataProperties.dataset.leverApiUrl + '?mode=json',
            function (data) {
                $.each(data, function (index, value) {
                    var listingItem = data[index];
                    var listingID = listingItem.id;

                    checkIfOpen(listingID);
                });

                if (openjob == 0) {
                    loadDefaultContent(openjob);
                } else {
                    loadJobContent(jobIdElement.value, openjob);
                }
            }
        );

        function checkIfOpen(id) {
            if (id == jobIdElement.value) {
                openjob = 1;
            }
        }
    }
});

function loadDefaultContent(openstatus) {
    var infoURL =
        dataProperties.dataset.leverApiUrl +
        '/' +
        dataProperties.dataset.leverDefaultJobId +
        '?mode=json';

    loadInInfo(infoURL, openstatus);
}

function loadJobContent(currentID, openstatus) {
    var infoURL =
        dataProperties.dataset.leverApiUrl + '/' + currentID + '?mode=json';

    loadInInfo(infoURL, openstatus);
}

function loadInInfo(theURL, openstatus) {
    $.get(theURL, function (data) {
        var jobTitle = document.getElementById('job-title').firstElementChild;
        var jobCommitmentLocation = document.getElementById(
            'commitment-location'
        );
        var applyButton1 = document.getElementById('apply-button-1');
        var applyButton2 = document.getElementById('apply-button-2');
        var jobOverview = document.getElementById('job-overview');
        var jobBenefits = document.getElementById('job-benefits');
        var jobDetailsCollection = Function(
            '"use strict";return (' +
            dataProperties.dataset.leverJobAttributeIdList +
            ')'
        )().map(function (jobAttributeId) {
            return document.getElementById(jobAttributeId);
        });

        if (openstatus == 0) {
            jobTitle.innerHTML = dataProperties.dataset.jobTitleFilled;

            jobCommitmentLocation.innerHTML =
                dataProperties.dataset.jobFilledMsg;

            applyButton1.innerText = dataProperties.dataset.applyNow;
            applyButton1.href = data.applyUrl;
            applyButton2.innerText = dataProperties.dataset.applyNow;
            applyButton2.href = data.applyUrl;
        } else {
            jobTitle.innerHTML = data.text;

            jobCommitmentLocation.innerHTML =
                data.categories.commitment +
                ' | ' +
                data.categories.team +
                ' | ' +
                data.categories.location;

            for (var index = 0; index < data.lists.length; index++) {
                var listItem = data.lists[index];

                var jobHeader = jobDetailsCollection[index * 2],
                    jobContent = jobDetailsCollection[index * 2 + 1];
                if (jobHeader && jobContent) {
                    jobHeader.innerHTML = listItem.text;
                    jobContent.innerHTML = listItem.content;
                }
            }

            jobBenefits.innerHTML = data.additional;

            applyButton1.innerText = dataProperties.dataset.joinNow;
            applyButton1.href = data.applyUrl;
            applyButton2.innerText = dataProperties.dataset.joinNow;
            applyButton2.href = data.applyUrl;
        }

        jobOverview.innerHTML = data.description;
    });
}
